import { render, staticRenderFns } from "./DSCrossCircleIcon.vue?vue&type=template&id=3a4c3bb0&scoped=true&"
import script from "./DSCrossCircleIcon.vue?vue&type=script&lang=js&"
export * from "./DSCrossCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c3bb0",
  null
  
)

export default component.exports